<template>
  <main class="app-content">
    <div class="app-title">
      <div class="row">
        <div class="col-7">
          <h1><i class="fa fa-dashboard"></i> {{ $t('usageReport') }}</h1>
        </div>
        <div class="col-5">
          <time-range-picker :model="filterFormModel" :label="$t('time')" @change="load"
                             :defaultShortcut="2"></time-range-picker>
        </div>
      </div>
    </div>
    <div class="raw row">
      <div class="w-100">
        <div class="tile shadow">
          <div class="row">
            <div class="col-9">
              <h3 class="tile-title">{{ $t('clientCount') }}</h3>
            </div>
            <div class="col-3">
              <form-select
                :options="[
                  {value: null, text: $t('created')},
                  {value: 'using', text: $t('using')},
                ]"
                :model="filterFormModel" attribute="clientType" @change="getCount"
              ></form-select>
            </div>
          </div>
          <div v-if="count.client && count.client.length === 0"
               class="d-flex flex-column align-items-center justify-content-center"
               style="height: 350px">
            <font-awesome-icon icon="inbox" size="10x" />
            <br>
            <div class="tile-title">
              {{ $t('noData') }}
            </div>
          </div>
          <div v-else>
            <apexchart :height="300" :options="chart1Options" :series="chart1Data"></apexchart>
          </div>
        </div>
      </div>
    </div>
    <div class="raw row">
      <div class="w-100">
        <div class="tile shadow">
          <h3 class="tile-title">{{ $t('usingSocialNetworkAccount') }}</h3>
          <div v-if="count.socialNetworkAccountIsActive && count.socialNetworkAccountIsActive.total === 0"
               class="d-flex flex-column align-items-center justify-content-center"
               style="height: 350px">
            <font-awesome-icon icon="inbox" size="10x" />
            <br>
            <div class="tile-title">
              {{ $t('noData') }}
            </div>
          </div>
          <div v-else>
            <apexchart :height="350" :options="chart4Options" :series="chart4Data"></apexchart>
          </div>
        </div>
      </div>
      <div class="w-100">
        <div class="tile shadow">
          <h3 class="tile-title">{{ $t('socialNetworkAccount') }}</h3>
          <div v-if="count.socialNetworkAccount && count.socialNetworkAccount.length === 0"
               class="d-flex flex-column align-items-center justify-content-center"
               style="height: 350px">
            <font-awesome-icon icon="inbox" size="10x" />
            <br>
            <div class="tile-title">
              {{ $t('noData') }}
            </div>
          </div>
          <div v-else>
            <apexchart :height="300" :options="chart2Options" :series="chart2Data"></apexchart>
          </div>
        </div>
      </div>
    </div>
    <div class="raw row">
      <div class="w-100">
        <div class="tile shadow">
          <div class="row">
            <div class="col-7">
              <h3 class="tile-title">{{ $t('avgChart') }}</h3>
            </div>
            <div class="col-2">
              <form-select
                :options="[
                  {value: null, text: $t('byDays')},
                  {value: 'category', text: $t('byCategories')},
                ]"
                :model="filterFormModel" attribute="group" @change="getAvgExtend"
              ></form-select>
            </div>
            <div class="col-3">
              <form-select
                :options="[
                  {value: null, text: $t('avgMonthCount')},
                  {value: 'userLimit', text: $t('avgUser')},
                  {value: 'amount', text: $t('avgAmount')},
                ]"
                :model="filterFormModel" attribute="avgType" @change="getAvgExtend"
              ></form-select>
            </div>
          </div>
          <div v-if="dataAvgExtend.length === 0"
               class="d-flex flex-column align-items-center justify-content-center"
               style="height: 350px">
            <font-awesome-icon icon="inbox" size="10x" />
            <br>
            <div class="tile-title">
              {{ $t('noData') }}
            </div>
          </div>
          <div v-else>
            <apexchart :height="300" :options="chart3Options" :series="chart3Data"></apexchart>
          </div>
        </div>
      </div>
    </div>
    <div class="raw row">
      <div class="w-100">
        <div class="tile shadow">
          <div class="row">
            <div class="col-md">
              <h3 class="tile-title">{{ $t('table') }}</h3>
            </div>
            <div class="table-responsive c-template-table">
              <table class="table table-hover table-bordered">
                <thead>
                <tr class="bg-success">
                  <th class="text-center"></th>
                  <th class="text-center">{{ $t('customer') }}</th>
                  <th class="text-center">{{ $t('customerSegment') }}</th>
                  <th class="text-center">{{ $t('company') }}</th>
                  <th class="text-center">{{ $t('contact') }}</th>
                  <th class="text-center">{{ $t('callCampaign') }}</th>
                  <th class="text-center">{{ $t('emailCampaign') }}</th>
                  <th class="text-center">{{ $t('messageCampaign') }}</th>
                  <th class="text-center">{{ $t('opportunity') }}</th>
                  <th class="text-center">{{ $t('task') }}</th>
                  <th class="text-center">{{ $t('product') }}</th>
                  <th class="text-center">{{ $t('productOrder') }}</th>
                  <th class="text-center">Ticket</th>
                  <th class="text-center">{{ $t('automation') }}</th>
                  <th class="text-center">{{ $t('call') }}</th>
                  <th class="text-center">SMS</th>
                  <th class="text-center">Viber</th>
                  <th class="text-center">ZNS</th>
                  <th class="text-center">Zalo OA</th>
                  <th class="text-center">Facebook</th>
                  <th class="text-center">{{ $t('socialNetworkAccount') }}</th>
                  <th class="text-center">{{ $t('clientUser') }}</th>
                  <th class="text-center">{{ $t('clientFaq') }}</th>
                  <th class="text-center">{{ $t('productWarehouse') }}</th>
                  <th class="text-center">Google Sheet</th>
                  <th class="text-center">The Alita</th>
                  <th class="text-center">Nhanh.vn</th>
                  <th class="text-center">Getfly</th>
                  <th class="text-center">KiotViet</th>
                </tr>
                </thead>
                <tbody>
                <tr class="bg-warning">
                  <td style="min-width: 200px"><b>Số lượng</b></td>
                  <td class="text-center"><span class="text-blue">{{ count.customer | numFormat }}</span></td>
                  <td class="text-center"><span class="text-blue">{{ count.customerSegment | numFormat }}</span></td>
                  <td class="text-center"><span class="text-blue">{{ count.company | numFormat }}</span></td>
                  <td class="text-center"><span class="text-blue">{{ count.contact | numFormat }}</span></td>
                  <td class="text-center"><span class="text-blue">{{ count.callCampaign | numFormat }}</span></td>
                  <td class="text-center"><span class="text-blue">{{ count.emailCampaign | numFormat }}</span></td>
                  <td class="text-center"><span class="text-blue">{{ count.messageCampaign | numFormat }}</span></td>
                  <td class="text-center"><span class="text-blue">{{ count.opportunity | numFormat }}</span></td>
                  <td class="text-center"><span class="text-blue">{{ count.task | numFormat }}</span></td>
                  <td class="text-center"><span class="text-blue">{{ count.product | numFormat }}</span></td>
                  <td class="text-center"><span class="text-blue">{{ count.productOrder | numFormat }}</span></td>
                  <td class="text-center"><span class="text-blue">{{ count.ticket | numFormat }}</span></td>
                  <td class="text-center"><span class="text-blue">{{ count.automation | numFormat }}</span></td>
                  <td class="text-center"><span class="text-blue">{{ count.call | numFormat }}</span></td>
                  <td class="text-center"><span class="text-blue">{{ count.sms | numFormat }}</span></td>
                  <td class="text-center"><span class="text-blue">{{ count.viber | numFormat }}</span></td>
                  <td class="text-center"><span class="text-blue">{{ count.zns | numFormat }}</span></td>
                  <td class="text-center"><span class="text-blue">{{ count.zalo | numFormat }}</span></td>
                  <td class="text-center"><span class="text-blue">{{ count.facebook | numFormat }}</span></td>
                  <td class="text-center">
                  <span class="text-blue">
                    {{ count.socialNetworkAccountCount | numFormat }}
                  </span>
                  </td>
                  <td class="text-center"><span class="text-blue">{{ count.clientUser | numFormat }}</span></td>
                  <td class="text-center"><span class="text-blue">{{ count.clientFaq | numFormat }}</span></td>
                  <td class="text-center"><span class="text-blue">{{ count.productWarehouse | numFormat }}</span></td>
                  <td class="text-center"><span class="text-blue">{{ count.googleSheet | numFormat }}</span></td>
                  <td class="text-center"><span class="text-blue">{{ count.theAlita | numFormat }}</span></td>
                  <td class="text-center"><span class="text-blue">{{ count.nhanhVn | numFormat }}</span></td>
                  <td class="text-center"><span class="text-blue">{{ count.getfly | numFormat }}</span></td>
                  <td class="text-center"><span class="text-blue">{{ count.kiotviet | numFormat }}</span></td>
                </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  </main>
</template>

<script>
import TimeRangePicker from '@/components/TimeRangePicker.vue'
import VueApexCharts from 'vue-apexcharts'
import moment from 'moment'

export default {
  components: { TimeRangePicker, 'apexchart': VueApexCharts },
  data() {
    return {
      count: {},
      filterFormModel: {
        avgType: null,
        group: null,
        clientType: null
      },
      dataAvgExtend: [],
      chart1Options: {
        xaxis: {},
        chart: {
          zoom: {
            enabled: false
          },
          type: 'bar'
        }
      },
      chart1Data: [],
      chart2Options: {
        xaxis: {},
        chart: {
          zoom: {
            enabled: false
          },
          type: 'bar'
        }
      },
      chart2Data: [],
      chart3Options: {
        xaxis: {},
        chart: {
          zoom: {
            enabled: false
          },
          type: 'bar'
        }
      },
      chart3Data: [],
      chart4Options: {
        xaxis: {},
        chart: {
          zoom: {
            enabled: false
          },
          type: 'pie'
        }
      },
      chart4Data: [],
      loading: true
    }
  },
  methods: {
    getCount() {
      let loader = this.$loading.show()
      this.$service.get('/report/count', { params: this.filterFormModel }).then(response => {
        if (response.data) {
          this.count = response.data

          this.chart1Options = {
            colors: ['#008ffb', '#feb019', '#00e396'],
            dataLabels: {
              enabled: true,
              style: {
                fontSize: '12px',
                colors: ['#fff']
              },
              formatter: function(value) {
                return new Intl.NumberFormat().format(value)
              }
            },
            chart: {
              zoom: { enabled: false },
              type: 'bar',
              stacked: true
            },
            yaxis: {
              tooltip: {
                enabled: false
              },
              labels: {
                formatter: function(value) {
                  return new Intl.NumberFormat().format(value)
                }
              }
            },
            xaxis: {
              categories: this.count.client.map(d => d.label)
            }
          }
          this.chart1Data = [
            {
              name: this.$t('trial'),
              data: this.count.client.map(item => item.trial)
            },
            {
              name: this.$t('expired'),
              data: this.count.client.map(item => item.expired)
            },
            {
              name: this.$t('activating'),
              data: this.count.client.map(item => item.activating)
            }
          ]

          this.chart2Options = {
            colors: ['#008ffb', '#feb019', '#ff4560', '#00e396'],
            dataLabels: {
              enabled: true,
              style: {
                fontSize: '12px',
                colors: ['#fff']
              },
              formatter: function(value) {
                return new Intl.NumberFormat().format(value)
              }
            },
            chart: {
              zoom: { enabled: false },
              type: 'bar',
              stacked: true
            },
            yaxis: {
              tooltip: {
                enabled: false
              },
              labels: {
                formatter: function(value) {
                  return new Intl.NumberFormat().format(value)
                }
              }
            },
            xaxis: {
              categories: this.count.socialNetworkAccount.map(d => this.label(d)).slice(0, 99).reverse()
            }
          }
          this.chart2Data = [
            {
              name: 'Facebook',
              data: this.count.socialNetworkAccount.map(item => item.facebook).slice(0, 99).reverse()
            },
            {
              name: 'Zalo',
              data: this.count.socialNetworkAccount.map(item => item.zalo).slice(0, 99).reverse()
            },
            {
              name: 'Instagram',
              data: this.count.socialNetworkAccount.map(item => item.instagram).slice(0, 99).reverse()
            },
            {
              name: 'Whatsapp',
              data: this.count.socialNetworkAccount.map(item => item.whatsapp).slice(0, 99).reverse()
            }
          ]

          this.chart4Options = {
            colors: ['#008ffb', '#feb019', '#ff4560', '#00e396'],
            labels: ['Facebook', 'Zalo', 'Instagram', 'WhatsApp'],
            chart: {
              zoom: { enabled: false },
              type: 'pie',
              toolbar: {
                show: true,
                offsetX: 0,
                offsetY: 0,
                tools: {
                  download: true
                }
              }
            },
            legend: {
              position: 'bottom'
            }
          }
          this.chart4Data = [
            this.count.socialNetworkAccountIsActive.facebook,
            this.count.socialNetworkAccountIsActive.zalo,
            this.count.socialNetworkAccountIsActive.instagram,
            this.count.socialNetworkAccountIsActive.whatsapp
          ]
        }
      }).catch(error => {
        if (error.response.data.message) {
          this.$swal({
            text: error.response.data.message,
            icon: 'error'
          })
        }
      }).finally(() => {
        loader.hide()
      })
    },
    getAvgExtend() {
      let loader = this.$loading.show()
      this.$bgService.get('/report/extend-order', { params: this.filterFormModel }).then(response => {
        if (response.data) {
          this.dataAvgExtend = response.data

          this.chart3Options = {
            colors: ['#008ffb'],
            dataLabels: {
              enabled: true,
              style: {
                fontSize: '12px',
                colors: ['#fff']
              },
              formatter: function(value) {
                return new Intl.NumberFormat().format(value)
              }
            },
            chart: {
              zoom: { enabled: false },
              type: 'bar'
            },
            yaxis: {
              tooltip: {
                enabled: false
              },
              labels: {
                formatter: function(value) {
                  return new Intl.NumberFormat().format(value)
                }
              }
            },
            xaxis: {
              categories: this.dataAvgExtend.map(d => this.label(d))
            }
          }
          this.chart3Data = [
            {
              name: this.filterFormModel.avgType === 'userLimit' ? this.$t('userLimit') : this.filterFormModel.avgType === 'amount' ? this.$t('amount') : this.$t('month'),
              data: this.dataAvgExtend.map(item => Math.round(item.data))
            }
          ]
        }
      }).finally(() => {
        loader.hide()
      })
    },
    label(item) {
      if (!isNaN(item._id)) {
        return moment(this.filterFormModel.from + item._id, 'x').format('DD/MM/YYYY')
      }
      return this.$t(item._id)
    },
    load() {
      this.getCount()
      this.getAvgExtend()
    }
  },
  mounted() {
    this.load()
  },
  i18n: {
    messages: {
      en: {
        usageReport: 'Usage report',
        clientCount: 'Customers number',
        noData: 'No data',
        trial: 'Trial',
        expired: 'Expired',
        activating: 'Activating',
        avgChart: 'Average customer renewals',
        avgMonthCount: 'Average renewal time (months)',
        avgUser: 'Average number of users renewing (users)',
        avgAmount: 'Average renewal amount (VND)',
        socialNetworkAccount: 'Social network account',
        active: 'Activating',
        deactivate: 'Deactivate',
        month: 'Number of months',
        userLimit: 'Number of users',
        amount: 'Amount of money',
        byDays: 'By days',
        byCategories: 'By categories',
        created: 'Created during the reporting period',
        using: 'Using the service package during the reporting period',
        usingSocialNetworkAccount: 'Number of social network accounts in use',
        customer: 'Customer',
        customerSegment: 'Customer segment',
        company: 'Company',
        contact: 'Contact',
        callCampaign: 'Call campaign',
        emailCampaign: 'Email campaign',
        messageCampaign: 'Message campaign',
        opportunity: 'Opportunity',
        task: 'Task',
        product: 'Product',
        productOrder: 'Order',
        automation: 'Automation',
        call: 'Call',
        clientUser: 'User',
        clientFaq: 'FAQ',
        productWarehouse: 'Warehouse',
        table: 'Usage statistics table'
      },
      vi: {
        usageReport: 'Báo cáo sử dụng',
        clientCount: 'Số lượng khách hàng',
        noData: 'Không có dữ liệu',
        trial: 'Dùng thử',
        expired: 'Hết hạn',
        activating: 'Còn hạn',
        avgChart: 'Khách hàng gia hạn trung bình',
        avgMonthCount: 'Thời gian gia hạn trung bình (tháng)',
        avgUser: 'Số user gia hạn trung bình (user)',
        avgAmount: 'Số tiền gia hạn trung bình (VNĐ)',
        socialNetworkAccount: 'Tài khoản mạng xã hội',
        active: 'Đang hoạt động',
        deactivate: 'Dừng hoạt động',
        month: 'Số tháng',
        userLimit: 'Số user',
        amount: 'Số tiền',
        byDays: 'Theo ngày',
        byCategories: 'Theo ngành',
        created: 'Được tạo trong kỳ báo cáo',
        using: 'Đang sử dụng gói dịch vụ trong kỳ báo cáo',
        usingSocialNetworkAccount: 'Số lượng tài khoản mạng xã hội đang sử dụng',
        customer: 'Khách hàng',
        customerSegment: 'Tập khách hàng',
        company: 'Công ty',
        contact: 'Liên hệ',
        callCampaign: 'Chiến dịch gọi hàng loạt',
        emailCampaign: 'Chiến dịch email',
        messageCampaign: 'Chiến dịch tin nhắn',
        opportunity: 'Cơ hội',
        task: 'Việc cần làm',
        product: 'Sản phẩm',
        productOrder: 'Đơn hàng',
        automation: 'Tự động hoá',
        call: 'Cuộc gọi',
        clientUser: 'User',
        clientFaq: 'Câu hỏi thường gặp',
        productWarehouse: 'Kho vận',
        table: 'Bảng thống kê sử dụng'
      }
    }
  }
}
</script>